import { TicketStatus } from '../redux-toolkits/events/events.type'
import {
  OrderChannelStatus,
  OrderStatus,
} from '../redux-toolkits/orders/orders.type'
import { CheckoutProvider } from '../redux-toolkits/cart/cart.type'
import { SettlementParty } from '../redux-toolkits/settlements/settlements.type'
import {
  ReportChannels,
  ReportPaymentMethods,
  ReportPeriodRange,
} from '../redux-toolkits/reports/reports.type'
import { TerminalProvider } from '../redux-toolkits/terminals/terminals.types'
import { RefundStatus } from '../redux-toolkits/refunds/refunds.type'
import { BusinessAvailableHours } from '../redux-toolkits/vendors/vendors.types'
import { VoucherSource } from '../redux-toolkits/voucher/voucher.type'
import { StatusTone } from '../redux-toolkits/shared/shared.type'
export const COOKIE_KEY = process.env.REACT_APP_AUTH_COOKIE_KEY! ?? '@goo'
export const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL
export const GOOD_ONLINE_BACKEND_BASE_URL =
  process.env.REACT_APP_GOOD_ONLINE_BACKEND_BASE_URL
export const IMAGES_BACKEND_BASE_URL =
  process.env.REACT_APP_IMAGES_BACKEND_BASE_URL
export const IS_LIVE = Boolean(Number(process.env.REACT_APP_IS_LIVE ?? 0))
const PRODUCTION_GOOD_ONLINE_BASE_URL = 'https://good.online'
const STAGING_GOOD_ONLINE_BASE_URL = 'https://web.staging.goodthingco.xyz'
const PRODUCTION_GOOD_LEKKI_BASE_URL = 'https://lekki.good.online'
const STAGING_GOOD_LEKKI_BASE_URL = 'https://lekki.staging.goodthingco.xyz'
export const GOOD_ONLINE_WEBSITE_NAME = 'Good Online'
export const GOOD_LEKKI_WEBSITE_NAME = 'Good Lekki'
export const GOOD_ONLINE_BASE_URL =
  process.env.REACT_APP_GOOD_ONLINE_BASE_URL ||
  (IS_LIVE ? PRODUCTION_GOOD_ONLINE_BASE_URL : STAGING_GOOD_ONLINE_BASE_URL)
export const GOOD_LEKKI_BASE_URL =
  process.env.REACT_APP_GOOD_LEKKI_BASE_URL ||
  (IS_LIVE ? PRODUCTION_GOOD_LEKKI_BASE_URL : STAGING_GOOD_LEKKI_BASE_URL)
export const COLLECTION_WEBSITE_OPTIONS = [
  {
    name: GOOD_ONLINE_WEBSITE_NAME,
    value: GOOD_ONLINE_BASE_URL,
  },
  {
    name: GOOD_LEKKI_WEBSITE_NAME,
    value: GOOD_LEKKI_BASE_URL,
  },
]
export const CURRENT_PAGE_NUMBER = 1
export const NUMBER_OF_ITEMS_PER_PAGE = 20
export const MAX_NO_PUBLISHED_LISTS = 10
export const PRIMARY_COLOR = '#F45D2C'
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY ?? ''
export const MONNIFY_API_KEY = String(
  process.env.REACT_APP_MONNIFY_API_KEY ?? '',
)

const monnifyEnvString = (value: string | undefined): string => {
  const str = String(value ?? '').trim()
  if (!str) return ''
  if (/e/i.test(str)) {
    const parsed = Number(str)
    return Number.isFinite(parsed) ? String(Math.trunc(parsed)) : str
  }
  return str
}

export const MONNIFY_CONTRACT_CODE = monnifyEnvString(
  process.env.REACT_APP_MONNIFY_CONTRACT_CODE,
)
export const MONNIFY_IS_TEST_MODE = Boolean(
  Number(process.env.REACT_APP_MONNIFY_IS_TEST_MODE ?? (IS_LIVE ? 0 : 1)),
)
export const SKELETON_BASE_COLOR = '#f3f4f6'
export const SKELETON_HIGHLIGHT_COLOR = '#ffffff80'

export const ORDERSTATUS: {
  id: number
  name: OrderStatus
  type: StatusTone
}[] = [
  {
    id: 1,
    name: 'PROCESSING',
    type: 'warn',
  },
  {
    id: 2,
    name: 'PENDING',
    type: 'warn',
  },
  {
    id: 3,
    name: 'PREPARING_PICKUP',
    type: 'warn',
  },
  {
    id: 4,
    name: 'SCHEDULED',
    type: 'warn',
  },
  {
    id: 5,
    name: 'READY_FOR_PICKUP',
    type: 'warn',
  },
  {
    id: 6,
    name: 'PREPARING_DELIVERY',
    type: 'warn',
  },
  {
    id: 7,
    name: 'SHIPPED',
    type: 'warn',
  },
  {
    id: 8,
    name: 'PICKED_UP',
    type: 'success',
  },
  {
    id: 9,
    name: 'DELIVERED',
    type: 'success',
  },
  {
    id: 10,
    name: 'COMPLETED',
    type: 'success',
  },
  {
    id: 11,
    name: 'CANCELLED',
    type: 'fail',
  },
  {
    id: 12,
    name: 'ABANDONED',
    type: 'fail',
  },
  {
    id: 13,
    name: 'REFUNDED',
    type: 'blue',
  },
  {
    id: 14,
    name: 'PARTIALLY_REFUNDED',
    type: 'blue',
  },
]

export const SETTLEMENTSTATUS = [
  {
    id: 1,
    name: 'SUCCESS',
    type: 'success',
  },
  {
    id: 2,
    name: 'FAILED',
    type: 'fail',
  },
  {
    id: 3,
    name: 'PENDING_CONFIRMATION',
    type: 'warn',
  },
  {
    id: 4,
    name: 'PENDING',
    type: 'warn',
  },
  {
    id: 5,
    name: 'COMPLETED',
    type: 'success',
  },
]

export const partyMappings: Record<SettlementParty, string> = {
  GOOD_THING: 'Good Operations',
  OTHERS: 'Others',
  REFERRAL: 'Referral',
  AMBASSADOR: 'Ambassador',
  STAKEHOLDER: 'Stakeholder',
  VENDOR: 'Creator',
  AFFILIATE: 'Affiliate',
}

export const DISABLE__DELIVERY_REQUEST__FROM = 6

export const defaultAvailableHours: BusinessAvailableHours = {
  monday: { open: false },
  tuesday: { open: false },
  wednesday: { open: false },
  thursday: { open: false },
  friday: { open: false },
  saturday: { open: false },
  sunday: { open: false },
}

export const settlementFilter: Record<
  SettlementParty | 'all',
  {
    name: string
    value: SettlementParty | 'all'
  }
> = {
  all: { name: 'All', value: 'all' },
  VENDOR: { name: 'Creator', value: 'VENDOR' },
  GOOD_THING: { name: 'Good Operations', value: 'GOOD_THING' },
  AMBASSADOR: {
    name: 'Ambassador',
    value: 'AMBASSADOR',
  },
  STAKEHOLDER: {
    name: 'Stakeholder',
    value: 'STAKEHOLDER',
  },
  REFERRAL: {
    name: 'Referrals',
    value: 'REFERRAL',
  },
  AFFILIATE: {
    name: 'Affiliate',
    value: 'AFFILIATE',
  },
  OTHERS: { name: 'Others', value: 'OTHERS' },
}

export const ReportChannelsMap: Record<
  ReportChannels,
  {
    name: string
    color: string
  }
> = {
  ANDROID_MOBILE: {
    name: 'Good Android',
    color: '!bg-amber',
  },
  IOS_MOBILE: {
    name: 'Good IOS',
    color: '!bg-red-650',
  },
  ONLINE: {
    name: 'Good Online',
    color: '!bg-cust-green',
  },
  POP: {
    name: 'Good House',
    color: '!bg-lime-green',
  },
  GOOD_HOUSE_PHYSICAL: {
    name: 'Good House Ikeja',
    color: '!bg-lime-green',
  },
}

export const ReportPaymentMethodsMap: Record<
  ReportPaymentMethods,
  {
    name: string
    color: string
  }
> = {
  DEBIT: {
    name: 'Good Wallet',
    color: '!bg-amber',
  },
  WALLET: {
    name: 'Good Wallet',
    color: '!bg-amber',
  },
  card: {
    name: 'Card',
    color: '!bg-lime-green',
  },
  pos: {
    name: 'POS',
    color: '!bg-cust-green',
  },
  bank_transfer: {
    name: 'Bank Transfer',
    color: '!bg-red-650',
  },
}

export const RefundStatusMap: Record<
  RefundStatus,
  {
    name: string
    pillVariant: StatusTone
  }
> = {
  PENDING: {
    name: 'Pending',
    pillVariant: 'warn',
  },
  CANCELLED: {
    name: 'Cancelled',
    pillVariant: 'fail',
  },
  REJECTED: {
    name: 'Rejected',
    pillVariant: 'fail',
  },
  APPROVED: {
    name: 'Approved',
    pillVariant: 'success',
  },
}

export const PeriodTextMap: Record<ReportPeriodRange, string> = {
  last_month: 'month',
  last_week: 'week',
  last_year: 'year',
  this_month: 'month',
  this_week: 'week',
  this_year: 'year',
  today: 'day',
  yesterday: 'day',
  inception_to_date: '',
}

export const OrderChannelMap: Record<
  OrderChannelStatus | 'all',
  {
    text: string
  }
> = {
  all: {
    text: 'All',
  },
  GOOD_HOUSE_PHYSICAL: {
    text: 'Good Physical',
  },
  ONLINE: {
    text: 'Good Online',
  },
}

export const OrderStatusMap: Record<
  OrderStatus | 'all',
  {
    text: string
  }
> = {
  all: {
    text: 'All',
  },
  OPEN: {
    text: 'Open',
  },
  PROCESSING: {
    text: 'Processing',
  },
  PENDING: {
    text: 'Pending',
  },
  PREPARING_PICKUP: {
    text: 'Preparing Pickup',
  },
  SCHEDULED: {
    text: 'Scheduled',
  },
  READY_FOR_PICKUP: {
    text: 'Ready for Pickup',
  },
  PREPARING_DELIVERY: {
    text: 'Preparing Delivery',
  },
  SHIPPED: {
    text: 'Shipped',
  },
  PICKED_UP: {
    text: 'Picked Up',
  },
  DELIVERED: {
    text: 'Delivered',
  },
  COMPLETED: {
    text: 'Completed',
  },
  CANCELLED: {
    text: 'Cancelled',
  },
  ABANDONED: {
    text: 'Abandoned',
  },
  REFUNDED: {
    text: 'Refunded',
  },
  PARTIALLY_REFUNDED: {
    text: 'Partially Refunded',
  },
}

export const voucherSourceMap: Record<
  VoucherSource,
  {
    text: string
  }
> = {
  ADMIN_GENERATED: {
    text: 'Good issued',
  },
  GIFT_CARD_PURCHASE: {
    text: 'Gift card',
  },
  REFERRAL: {
    text: 'Referral',
  },
  OTHER: {
    text: 'Other',
  },
}

export const ticketStatusMap: Record<
  TicketStatus,
  {
    text: string
    pillVariant: StatusTone
  }
> = {
  ACTIVE: {
    text: 'Unused',
    pillVariant: 'warn',
  },
  CANCELLED: {
    text: 'Cancelled',
    pillVariant: 'fail',
  },
  CHECKED_IN: {
    text: 'Checked In',
    pillVariant: 'success',
  },
  EXPIRED: {
    text: 'Expired',
    pillVariant: 'fail',
  },
}

export const terminalProviderMap: Record<
  TerminalProvider,
  {
    text: string
    pillVariant: StatusTone
  }
> = {
  PAYSTACK: {
    text: 'Paystack',
    pillVariant: 'blue',
  },
  MONIEPOINT: {
    text: 'Moniepoint',
    pillVariant: 'blue',
  },
}

export const checkoutProviderMap: Record<
  CheckoutProvider,
  {
    text: string
    pillVariant: StatusTone
  }
> = {
  PAYSTACK: {
    text: 'Paystack',
    pillVariant: 'blue',
  },
  MONNIFY: {
    text: 'Monnify',
    pillVariant: 'blue',
  },
}
